import { useLang } from "@/lib/i18n";

export const MOODS = ["senang", "sedih", "marah", "terkejut", "malu", "berpikir", "semangat", "mengantuk", "bingung", "bagus", "luar_biasa", "perfect", "coba_lagi"];
const STATUS_MOOD = { advance: "luar_biasa", on_track: "bagus", delay: "berpikir", not_achieve: "coba_lagi", no_data: "mengantuk" };

export const moodForStatus = (status) => STATUS_MOOD[status] || "mengantuk";
export const moodForScore = (score) => (score == null ? "mengantuk" : score >= 100 ? "perfect" : score >= 90 ? "semangat" : score >= 80 ? "senang" : score >= 70 ? "berpikir" : "sedih");

export const Oreo = ({ mood = "senang", size = 56, caption = false, message, className = "", testId }) => {
  const { t } = useLang();
  return (
    <div data-testid={testId || `oreo-${mood}`} data-mood={mood} className={`inline-flex items-center gap-2 ${className}`}>
      <img src={`/oreo/${mood}.png`} alt={`OREO ${t(`m_${mood}`)}`} width={size} height={size} className="rounded-lg object-contain shrink-0 select-none" draggable={false} />
      {(caption || message) && (
        <div className="leading-tight">
          {caption && <div className="font-heading font-bold text-xs uppercase tracking-wider text-slate-900" data-testid="oreo-caption">{t(`m_${mood}`)}</div>}
          {(message ?? (caption && t(`c_${mood}`))) && <div className="text-[11px] text-slate-500" data-testid="oreo-message">{message ?? t(`c_${mood}`)}</div>}
        </div>
      )}
    </div>
  );
};

export const OreoEmpty = ({ mood = "bingung", text, testId }) => {
  const { t } = useLang();
  return (
    <div data-testid={testId || "oreo-empty"} className="flex flex-col items-center justify-center py-8 gap-2 text-slate-500">
      <img src={`/oreo/${mood}.png`} alt="OREO" width={72} height={72} className="rounded-lg opacity-90" draggable={false} />
      <div className="text-sm">{text || t(`c_${mood}`)}</div>
    </div>
  );
};
